import type { PlatformAdapter } from './PlatformAdapter';

/** Single call site for teardown so consumers do not repeat `adapter.detachMeasurementListeners()`. */
export function detachAdapterMeasurementListeners(adapter: PlatformAdapter): void {
  adapter.detachMeasurementListeners();
}
